module.exports = __webpack_public_path__ + "static/media/selec-nft-8.0c8ef894.png";